import React from "react";
import { gql } from "@apollo/client";

import { Typography } from "@mui/material";
import { MessageDraw as CommentIcon } from "mdi-material-ui";

const Icon = () => <CommentIcon />;

const Title = () => <span>Commentaire</span>;

const Content = ({ orderEvent }) => (
  <Typography style={{ whiteSpace: "pre-wrap" }}>
    {orderEvent.message}
  </Typography>
);

const fragments = {
  orderEvent: gql`
    fragment Orders_OrderEvent_CommentEvent_OrderEvent on OrderEvent {
      id

      ... on OrderEvent_Comment {
        message
      }
    }
  `,
};

const Event = {
  Icon,
  Title,
  Content,
  fragments,
};

export default Event;
